var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v("MI DIRECORIO DE MÉDICOS")])])],1),_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"green lighten-2",attrs:{"dark":""}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" Añadir")],1)],1)],1),_c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"headers":[
          {text: 'Nombre', value: 'nombre_completo'},
          {text: 'Especialidad', value: 'especialidad'} ],"items":[
          {nombre_completo: 'Luis Ruelas', especialidad: 'Médico General'}
        ]}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }